import React from 'react';
import Icon from '../../Icon';

const MobileNavigationItem = ({
  link,
  name,
  url,
  onLinkClick,
}: {
  link?: any;
  name: string;
  url: string;
  onLinkClick?: (link: any) => void;
}) => {
  return (
    <li className="flex justify-between text-lg font-bold [&:not(:last-child)]:border-b [&:not(:last-child)]:border-gray-700">
      <a
        className="flex-1 p-4 lowercase text-white [&:first-letter]:capitalize"
        href={url}
      >
        {name}
      </a>
      {onLinkClick && link && link.links?.length > 0 && (
        <div
          className="flex h-14 w-14 cursor-pointer items-center justify-center border-l border-gray-700"
          onClick={() => onLinkClick(link)}
        >
          <Icon className="h-5 w-5 text-white" name="chevron-right" />
        </div>
      )}
    </li>
  );
};
export default MobileNavigationItem;
